import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import AssignedPlanDetailPreview from "../../../AssignedPlans/components/AssignedPlanDetailPreview";

const PreviewAutoPlan = ({
  activeAutoPlanActionId,
  autoPlanPreview,
  closeAutoPlanPreview,
  previewAutoPlanAction,
}) => (
  <Modal
    show
    id="preview-auto-plan-modal"
    onHide={closeAutoPlanPreview}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[900px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title={`Auto Plan: ${autoPlanPreview.name}`} closeButton />

    <Modal.Body>
      <AssignedPlanDetailPreview
        activeAutoPlanActionId={activeAutoPlanActionId}
        autoPlanPreview={autoPlanPreview}
        previewAutoPlanAction={previewAutoPlanAction}
      />
    </Modal.Body>
  </Modal>
);

PreviewAutoPlan.propTypes = {
  activeAutoPlanActionId: PropTypes.number.isRequired,
  autoPlanPreview: PropTypes.shape().isRequired,
  closeAutoPlanPreview: PropTypes.func.isRequired,
  previewAutoPlanAction: PropTypes.func.isRequired,
};

export default PreviewAutoPlan;
